<template>
    <div
        class="w-100 cursor-pointer transition-all px-10 py-2 bg-try rounded-pill primary--border d-flex flex-row justify-center align-center primary--text position-relative"
        @click="playOrPauseTrack"
    >
        <div
            class="line-progress rounded-pill position-absolute"
            :style="`width: ${progress}%;`"
        />
        <span class="font-size-18">{{ $t('bookReading.listen_background_music') }}</span>
        <v-icon class="primary--text mx-3">
            {{ isPaused ? 'mdi-volume-high' : 'mdi-volume-off' }}
        </v-icon>
        <audio id="try_sound" v-show="false" />
    </div>
</template>
<script>
import { mapState } from 'vuex'

import global from '@/constants/GlobalConstant'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    data() {
        return {
            progress: 0,
            audioEl: null,
            progressPill: 100 / 30,
            playInterval: null,
            track: 'Relajacion_A.mp3',
            isPaused: true,
            playReady: false,
        }
    },
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            challengeConf: (state) => state.challenge.config,
        }),
        volume() {
            let result = this.bookReadConf && this.bookReadConf.sound
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConf && this.challengeConf.soundVol
            }
            return result
        },
    },
    watch: {
        volume(newValue) {
            this.setVolume(newValue)
        },
    },
    mounted() {
        const el = document.getElementById('try_sound')
        if (el) this.audioEl = el
        this.setTrack()
        this.setVolume(this.volume)
    },
    methods: {
        playOrPauseTrack() {
            if (this.audioEl.paused) {
                this.audioEl.play()
                    .then(() => { this.playReady = true })
                    .catch(() => { this.playReady = false });
                this.isPaused = this.audioEl.paused
                const vm = this
                this.playInterval = setInterval(() => {
                    vm.progress += vm.progressPill
                    if (vm.progress >= 100) {
                        vm.clearPlayInterval()
                    }
                }, 1000)
            } else {
                this.clearPlayInterval()
            }
        },
        clearPlayInterval() {
            this.progress = 0
            if (this.playReady && this.audioEl && !this.audioEl.paused) {
                this.audioEl.pause()
                this.isPaused = this.audioEl.paused
                this.audioEl.currentTime = 0
                this.setTrack()
                window.clearInterval(this.playInterval)
            }
        },
        setTrack() {
            const index = Math.random() * (global.ZEND_SOUNDS.length - 1)
            this.track = `${global.ZEND_MUSIC_URI}${global.ZEND_SOUNDS[index.toFixed()]}`
            this.audioEl.src = this.track
        },
        setVolume(vol) {
            this.audioEl.volume = vol / 100
        },
    },
}
</script>

<style scoped>
.primary--border {
    border: 1.5px solid #514773 !important;
}
.bg-try {
    background: white !important;
}
.bg-try:hover {
    background: rgb(216, 216, 216) !important;
}

.line-progress {
    background: #756b9546 !important;
    left: 0;
    height: 100%;
    transition: all 1s linear;
}
</style>
